import React from 'react';
import { capitalize } from 'lodash';
import { FormattedAddress, SummaryGridItem, SummarySection, TaxId, ErrorComponents, TaxExempt } from '@css-xp/base';
import { FetchInvoiceGroupQuery } from '@css-xp/graphtypes';

export const InvoiceGroupSummary = ({ invoiceGroup }: { invoiceGroup: FetchInvoiceGroupQuery }) => {
  if (!invoiceGroup?.invoiceGroup) {
    return (
      <ErrorComponents.ErrorPanel
        error={new ErrorComponents.NotFoundError(`Unable to find invoice group for page summary.`)}
      />
    );
  }

  const {
    shipToParty: shipToAddress,
    recipients,
    defaultPaymentMethod,
    currency,
    purchaseOrder,
  } = invoiceGroup?.invoiceGroup;

  return (
    <SummarySection columns="1fr 1fr 1fr" className="transaction-account-summary">
      <SummaryGridItem>
        <div className="bill-to-address">
          <label>{shipToAddress?.addressLine1 ? 'Ship to address' : 'No address information'}</label>
          <div className="address-details">
            <FormattedAddress
              addressLine1={shipToAddress?.addressLine1}
              addressLine2={shipToAddress?.addressLine2}
              city={shipToAddress?.city}
              country={shipToAddress?.country}
              postcode={shipToAddress?.postcode}
              state={shipToAddress?.state}
            />
          </div>
          <br />
          <TaxId taxId={shipToAddress?.taxId} />
          <br />
          {/* <FeatureSwitch flag={ENABLE_TAX_EXEMPT}> */}
          {/* <Enabled> */}
          <TaxExempt taxExempt={shipToAddress?.taxExempt ? 'Yes' : 'No'} />
          {/* </Enabled> */}
          {/* </FeatureSwitch> */}
        </div>
      </SummaryGridItem>
      <SummaryGridItem>
        <div className="bill-to-address">
          {shipToAddress?.shipToPriceEligibility ? (
            <>
              <label>Price eligibility</label>
              <div>{capitalize(shipToAddress.shipToPriceEligibility)}</div>
            </>
          ) : (
            <label>No price eligibility</label>
          )}
          <br />

          <label>Payment method</label>

          <div>{defaultPaymentMethod?.type}</div>
          <br />
          <label>Currency</label>

          <div>{currency}</div>
        </div>
      </SummaryGridItem>
      <SummaryGridItem>
        <div className="bill-to-address">
          {recipients && recipients.length > 0 ? (
            <>
              <label>Invoice to recipients</label>
              <ul
                style={{
                  listStyleType: 'none',
                  paddingLeft: 0,
                }}
              >
                {recipients.map((recipient: any) => (
                  <li key={recipient}>{recipient}</li>
                ))}
              </ul>
            </>
          ) : (
            <label>No recipients found</label>
          )}
          <br />
          {/* <FeatureSwitch flag={ENABLE_PO_NUMBER_INVOICE_GROUP}> */}
          {/* <Enabled> */}
          {purchaseOrder && purchaseOrder?.number ? (
            <>
              <label>Purchase order</label>
              <div>{purchaseOrder.number}</div>
              <div>({purchaseOrder?.oneTimeUse ? 'Single-use' : 'Multi-use'})</div>
            </>
          ) : (
            <label>No purchase order number found</label>
          )}
          {/* </Enabled> */}
          {/* </FeatureSwitch> */}
        </div>
      </SummaryGridItem>
    </SummarySection>
  );
};
